<template>
  <q-card
    class="column bg-transparent"
    flat
    bordered
  >
    <q-card-section
      class="row text-h6 bg-primary"
      :class="$getTextColor(currentSite, 'primary')"
    >
      {{ item.name }}
    </q-card-section>
    <q-card-section
      class="row q-pa-none"
    >
      <q-list
        class="full-width"
        separator
      >
        <q-item
          v-for="itemVariation in item.itemVariations.data"
          :key="itemVariation.id"
          class="row"
        >
          <q-item-section class="col">
            <div
              class="text-subtitle2"
              style="font-size: 1rem; line-height: 1.5;"
            >
              {{ itemVariation.name }}
            </div>
            <div
              v-if="itemVariation.description"
              class="text-caption"
              style="line-height: 1;"
            >
              {{ itemVariation.description }}
            </div>
          </q-item-section>
          <q-item-section class="col-auto q-px-md">
            <i18n-n
              class="text-subtitle1"
              tag="span"
              :value="itemVariation.price"
              format="currency"
              scope="global"
            />
          </q-item-section>
          <q-item-section class="col-auto">
            <div class="row">
              <q-btn
                class="col-auto"
                :class="{ 'text-grey': activityBooking.salesItemCount(itemVariation) < 1 }"
                icon="fal fa-minus"
                dense
                square
                outline
                :disable="activityBooking.salesItemCount(itemVariation) < 1"
                @click.stop="decrementSalesItem(itemVariation)"
              />
              <div
                class="col-auto text-h5 q-px-md"
              >
                {{ activityBooking.salesItemCount(itemVariation) }}
              </div>
              <q-btn
                class="col-auto"
                icon="fal fa-plus"
                dense
                square
                outline
                @click.stop="activityBooking.incrementSalesItem(itemVariation)"
              />
            </div>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
  </q-card>
</template>

<script>
import { useRemoveOrderItem } from 'src/composables/order/order-items/RemoveOrderItem'
import ActivityBooking from 'src/models/activity/ActivityBooking'
import Item from 'src/models/item/Item'
import { ORDER_ITEM_STATES } from 'src/models/order-item/OrderItem'

export default {
  name: 'ActivitySalesItemCard',
  configuration: ['currentSite'],
  inject: ['order'],
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    },
    item: {
      type: Item,
      required: true
    }
  },
  setup () {
    const { removeOrderItem } = useRemoveOrderItem()
    return {
      removeOrderItem
    }
  },
  methods: {
    decrementSalesItem (itemVariation) {
      const lastAddedOrderItem = _.findLast(this.order.draftOrderItems, orderItem => {
        if (orderItem.state !== ORDER_ITEM_STATES.DRAFT) return false
        if (!_.isNil(orderItem.itemPackageId)) return false
        if (orderItem.itemOrderItem?.itemVariationId !== itemVariation.id) return false
        if (orderItem.itemOrderItem?.activityBookingId !== this.activityBooking.id) return false

        return true
      })

      if (!_.isNil(lastAddedOrderItem)) {
        this.removeOrderItem(lastAddedOrderItem)
      }
    }
  }
}
</script>
